import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'app-improvement-target-title',
  templateUrl: './improvement-target-title.component.html',
  styleUrl: './improvement-target-title.component.css'
})
export class ImprovementTargetTitleComponent implements ICellRendererAngularComp  {
  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  params;

  agInit(params): void {
    this.params = params;
  }
}
